import {
  BroadcastFeedType,
  CampaignFeedType,
  GroupFeedType,
  HomeFeedType,
  HomeMomentsFeedType,
  InboxFeedType,
  MyLeadersFeedType,
  NetworkQuestionFeedType,
  NetworkQuestionInboxFeedType,
  TeamsMeetingFeedType,
  TopicFeedType,
  TopicNetworkQuestionFeedType,
  UserMomentsFeedType,
} from '@ms/yammer-graphql';

import { FeedType } from '../../state/types';

import { FeedIdentifier } from './types';

type GetFeedId = (options: FeedIdentifier) => string;

const defaultFeedSubtypeMap: Record<FeedType, FeedIdentifier['subtype']> = {
  [FeedType.AttachableLink]: undefined,
  [FeedType.Bookmark]: undefined,
  [FeedType.Group]: GroupFeedType.ALL,
  [FeedType.Campaign]: CampaignFeedType.ALL,
  [FeedType.Home]: HomeFeedType.DISCOVERY,
  [FeedType.HomeMoments]: HomeMomentsFeedType.DEFAULT,
  [FeedType.Inbox]: InboxFeedType.ALL,
  [FeedType.InboxDraft]: undefined,
  [FeedType.LeaderEmployees]: undefined,
  [FeedType.LeadersDiscovery]: undefined,
  [FeedType.LiveEvent]: BroadcastFeedType.ALL,
  [FeedType.MyLeaders]: MyLeadersFeedType.ALL,
  [FeedType.DiscoveryNetworkQuestion]: undefined,
  [FeedType.NetworkQuestion]: NetworkQuestionFeedType.ALL,
  [FeedType.NetworkQuestionInbox]: NetworkQuestionInboxFeedType.ALL,
  [FeedType.SingleNetworkQuestion]: undefined,
  [FeedType.StorylineAll]: undefined,
  [FeedType.StorylineDiscovery]: undefined,
  [FeedType.StorylineFollowed]: undefined,
  [FeedType.TeamsMeeting]: TeamsMeetingFeedType.ALL,
  [FeedType.Topic]: TopicFeedType.ALL,
  [FeedType.TopicNetworkQuestion]: TopicNetworkQuestionFeedType.ALL,
  [FeedType.User]: undefined,
  [FeedType.UserMoments]: UserMomentsFeedType.DEFAULT,
  [FeedType.UserWall]: undefined,
};

type GetDefaultSubtype = (type: FeedType) => FeedIdentifier['subtype'];
export const getDefaultSubtype: GetDefaultSubtype = (type) => defaultFeedSubtypeMap[type];

export const getId: GetFeedId = ({ type, entityId, subtype }) => {
  if (type === FeedType.AttachableLink) {
    return attachableLinkFeedId;
  }

  const defaultedSubtype = subtype || getDefaultSubtype(type);
  // We don't want consumers manually constructing feed IDs, so we base64-encode them.
  const id = [type, entityId, defaultedSubtype].join('/');

  return `${id}-${btoa(id)}`;
};

export const networkQuestionInboxUnreadFeedId = getId({
  type: FeedType.NetworkQuestionInbox,
  subtype: NetworkQuestionInboxFeedType.UNREAD,
});

export const networkQuestionInboxAllFeedId = getId({
  type: FeedType.NetworkQuestionInbox,
  subtype: NetworkQuestionInboxFeedType.ALL,
});

export const networkQuestionInboxThreadStarterSenderFeedId = getId({
  type: FeedType.NetworkQuestionInbox,
  subtype: NetworkQuestionInboxFeedType.VIEWER_IS_THREAD_STARTER_SENDER,
});

export const inboxUnreadFeedId = getId({ type: FeedType.Inbox, subtype: InboxFeedType.UNREAD });

export const inboxDirectFeedId = getId({ type: FeedType.Inbox, subtype: InboxFeedType.DIRECT });

export const inboxAllFeedId = getId({ type: FeedType.Inbox, subtype: InboxFeedType.ALL });

export const attachableLinkFeedId = 'attachableLinkFeedId';
